import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFAB from "./WhatsAppFAB";
import { Toaster } from "./ui/sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#0B0F19] text-white font-body antialiased">
      <Header />
      <main className="pt-20 md:pt-24">{children}</main>
      <Footer />
      <WhatsAppFAB />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#131826",
            border: "1px solid rgba(244,123,32,0.4)",
            borderRadius: 0,
            color: "#fff",
          },
        }}
      />
    </div>
  );
}
